import { create } from "zustand";

/**
 * Whether the server turned call diagnostics on (CALL_DIAGNOSTICS_ENABLED,
 * staging only; #2224). Learned from the `livekit.call_diagnostics` field on
 * every token response. Read by the fault switch and, later, the "not heard"
 * warning's agreement mode. False until a response says otherwise.
 */
interface CallDiagnosticsState {
  enabled: boolean;
  set: (enabled: boolean) => void;
}

export const useCallDiagnosticsStore = create<CallDiagnosticsState>((set) => ({
  enabled: false,
  set: (enabled) => set({ enabled }),
}));

/** Records the flag from any response that carries a LiveKit token; passes the response through. */
export function noteCallDiagnostics<T>(response: T): T {
  const lk = (response as { livekit?: { call_diagnostics?: unknown } } | null | undefined)?.livekit;
  if (lk && typeof lk.call_diagnostics === "boolean") useCallDiagnosticsStore.getState().set(lk.call_diagnostics);
  return response;
}
